/**
 * PendingIndicatorIcon
 * 
 * Animated loading/pending indicator icon used in tabs and status displays.
 * Shows a partial circle with gradient fill to indicate pending state.
 */

interface PendingIndicatorIconProps {
  className?: string;
}

export function PendingIndicatorIcon({ className }: PendingIndicatorIconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Pending"
      className={className}
    >
      {/* Faded top-right segment */}
      <g opacity="0.5">
        <path
          d="M9.60653 1C10.0823 1.30539 10.5003 1.68997 10.8189 2.14615L10.3665 2.43762L10.3572 2.44511L9.90483 2.73658C9.66558 2.39392 9.35737 2.09838 9 1.86897L9.60653 1Z"
          fill="#F19600"
        />
      </g>
      {/* Faded ring segments */}
      <path
        opacity="0.5"
        d="M6.87988 1.58594C6.59652 1.52988 6.30246 1.5 6 1.5L6 -5.24537e-07C6.40076 -4.89501e-07 6.79214 0.0402952 7.1709 0.115234L6.87988 1.58594ZM4.83008 0.115234C5.20855 0.0404159 5.59958 -5.59543e-07 6 -5.24537e-07L6 1.5C5.69755 1.5 5.40348 1.52988 5.12012 1.58594L4.83008 0.115234ZM1.01172 2.66699C1.44976 2.01271 2.01272 1.44975 2.66699 1.01172L3.08399 1.63379L3.50098 2.25684C3.0096 2.5858 2.58581 3.0096 2.25684 3.50098L1.01172 2.66699ZM12 6C12 6.40069 11.9607 6.7922 11.8857 7.1709L10.4141 6.87988C10.4701 6.59652 10.5 6.30245 10.5 6C10.5 5.69755 10.4701 5.40348 10.4141 5.12012L11.8857 4.83008C11.9605 5.20849 12 5.59964 12 6ZM5.24537e-07 6C5.59543e-07 5.59957 0.0404171 5.20855 0.115235 4.83008L1.58594 5.12012C1.52988 5.40348 1.5 5.69754 1.5 6C1.5 6.30245 1.52988 6.59652 1.58594 6.87988L0.115235 7.1709C0.0402961 6.79214 4.89501e-07 6.40076 5.24537e-07 6ZM8.91602 10.3662L8.49902 9.74316C8.9904 9.41419 9.41419 8.9904 9.74316 8.49902L10.3662 8.91699L10.9893 9.33398C10.5513 9.98809 9.98809 10.5513 9.33398 10.9893L8.91602 10.3662ZM2.66699 10.9893C2.01275 10.5513 1.44979 9.98812 1.01172 9.33398L1.63379 8.91601L1.63477 8.91699L2.25684 8.49902C2.58581 8.9904 3.0096 9.41419 3.50098 9.74316L2.66699 10.9893ZM6 12C5.59964 12 5.20849 11.9605 4.83008 11.8857L5.12012 10.4141C5.40348 10.4701 5.69755 10.5 6 10.5C6.30245 10.5 6.59652 10.4701 6.87988 10.4141L7.1709 11.8857C6.7922 11.9607 6.40069 12 6 12Z"
        fill="#F19600"
      />
      {/* Solid active segments */}
      <path
        d="M12 6C12 6.40069 11.9607 6.7922 11.8857 7.1709L10.4141 6.87988C10.4701 6.59652 10.5 6.30245 10.5 6C10.5 5.69755 10.4701 5.40348 10.4141 5.12012L11.8857 4.83008C11.9605 5.20849 12 5.59964 12 6ZM8.91602 10.3662L8.49902 9.74316C8.9904 9.41419 9.41419 8.9904 9.74316 8.49902L10.3662 8.91699L10.9893 9.33398C10.5513 9.98809 9.98809 10.5513 9.33398 10.9893L8.91602 10.3662ZM2.66699 10.9893C2.01275 10.5513 1.44979 9.98812 1.01172 9.33398L1.63379 8.91601L1.63477 8.91699L2.25684 8.49902C2.58581 8.9904 3.0096 9.41419 3.50098 9.74316L2.66699 10.9893ZM6 12C5.59964 12 5.20849 11.9605 4.83008 11.8857L5.12012 10.4141C5.40348 10.4701 5.69755 10.5 6 10.5C6.30245 10.5 6.59652 10.4701 6.87988 10.4141L7.1709 11.8857C6.7922 11.9607 6.40069 12 6 12Z"
        fill="#F19600"
      />
    </svg>
  );
}

